<template>
  <div class="bg1" ref="setH">

    <!-- <bundleRenderer class="renderToStream3">


    </bundleRenderer> -->
    <div class="manageBox">
      <div class="leftBox">
        <!-- <div class="topCho">
          <el-radio-group v-model="roleType" size="medium" style="width: 100%">
            <el-radio-button label="1">学校</el-radio-button>
            <el-radio-button v-if="userModule.role == 'AreaManager'" label="2"
              >集团用户</el-radio-button
            >
          </el-radio-group>
        </div> -->

        <div class="haveCho" v-if="search.oid != ''">
          <el-tag
            v-if="search.oid != ''"
            size="small"
            @close="handleClose(1)"
            :closable="userModule.role == 'AreaManager'"
            >{{ search.oname }}</el-tag
          >
          <el-tag
            v-if="search.did != ''"
            size="small"
            @close="handleClose(2)"
            closable
            >{{ search.dname }}</el-tag
          >
        </div>
        <div class="treeBox">
          <el-tree
            class="filter-tree"
            :data="data"
            v-if="data.length > 0 && data.length != undefined"
            :props="defaultProps"
            default-expand-all
            @node-click="handleNodeClick"
            ref="tree"
          >
            <span class="custom-tree-node" slot-scope="{ node }">
              <span :title="node.label">{{ node.label }}</span>
            </span>
          </el-tree>
        </div>
        <!-- :filter-node-method="filterNode" -->
      </div>
      <div class="rightBox">
        <div class="topSearch">
          <em style="color:#666;padding-left:20px">人员名称：</em>
          <el-input
            v-model="search.uname"
            style="width: 150px; margin: 0 10px 0 0"
            size="small"
            placeholder="请输入内容"
          ></el-input
          ><el-button size="small" @click="getRoleList" type="primary"
            >查询</el-button
          >
        </div>
        <div class="dataBox">
          <el-table :data="tableData" style="width: 100%" border>
            <el-table-column
              prop="userName"
              label="人员"
             
            ></el-table-column>
            <el-table-column label="审核员">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.auditor"
                  @change="setRole(scope.row, 1)"
                >
                </el-switch>
              </template>
            </el-table-column>
            <!-- <el-table-column label="审核学校">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.schoolIdList"
                  multiple
                  filterable
                  @change="setSchool(scope.row)"
                  placeholder="请选择"
                  size="mini"
                  style="width: 280px"
                >
                  <el-option
                    v-for="item in schoolList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column> -->
            <el-table-column prop="address" label="专题资源管理" >
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.thematicResourceManager"
                  @change="setRole(scope.row, 2)"
                >
                </el-switch>
              </template>
            </el-table-column>
          </el-table>
          <div class="pages">
            <el-pagination
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              background
              layout="total, sizes, prev, pager, next"
              :total="pages.pageAll"
              :page-size="pages.pageSize"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import role from "../../mixins/role";
export default {
  name: "role",
  data() {
    return {
      ccc: "角色管理",
      tabH: 0,
      activeName: "first",
      roleType: "1",
      tableData: [],
      schoolList: [],
      search: {
        uname: "",
        oid: "",
        oname: "",
        did: "",
        dname: "",
      },
      pages: {
        pageIndex: 1,
        pageAll: 100,
        pageSize: 10,
      },
      filterText: "",
      data: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
    };
  },
  mixins: [role],
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    roleType: {
      handler(v) {
        this.search.oid = "";
        this.search.oname = "";
        this.getOrganization();
        this.getRoleList();
      },
    },
    "search.oid": {
      handler(v) {
        // this.getOrganization();
        this.getRoleList();
      },
    },
    "search.did": {
      handler(v) {
        // this.getOrganization();
        this.getRoleList();
      },
    },
  },
  methods: {
    init() {
      this.$nextTick(() => {
        this.tabH = this.$refs.setH.clientHeight - 120;
      });
      this.getSchoolList();
      if (window.sessionStorage.getItem("role") == "SchoolManager") {
        // this.search.oid = this.userModule.schoolId;
        this.search.oid = window.sessionStorage.getItem("schoolId");
        // this.search.oname = this.userModule.schoolName;
        this.search.oname = window.sessionStorage.getItem("schoolName");
      }

      setTimeout(() => {
        this.getOrganization();
      }, 100);
      this.getRoleList();
      // this.getDeptList()
    },
    // 获取组织结构
    getOrganization() {
      let that = this;
      let urlLink =
        that.roleType == "1"
          ? `/common/load/school/department`
          : `/common/load/area/department`;
      let pid = "";
      if (that.userModule.role == "SchoolManager") {
        pid = that.userModule.schoolId;
      } else if (that.userModule.role == "AreaManager") {
        pid = that.userModule.areaId;
      }
      let param = { parentId: pid };
      that.$ajax.post(urlLink, param).then((res) => {
        console.log("获取组织结构列表", res);
        if (that.roleType == "1" && that.userModule.role == "AreaManager") {
          that.data = that.schoolList;
        } else {
          that.data = res;
        }
      });
    },
    // 选中树节点
    handleNodeClick(event) {
      console.log(event);
      if (this.search.oid == "") {
        this.search.oid = event.code;
        this.search.oname = event.name;
      } else {
        this.search.did = event.code;
        this.search.dname = event.name;
      }
      this.getChild(event.code);
    },
    // 获取子节点
    getChild(event) {
      let urlLink =
        this.roleType == "1"
          ? `/common/load/school/department`
          : `/common/load/area/department`;
      let param = { parentId: event };
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("子结构结构列表", res);
        this.data = res;
      });
    },
    // 获取学校列表
    getSchoolList() {
      let urlLink = `/common/load/group/school`;
      this.$ajax.post(urlLink).then((res) => {
        console.log("获取学校列表", res);
        this.schoolList = res;
      });
    },
    getDeptList () {
      this.$ajax.post("/common/load/school/department",{ orgId: this.search.oid}).then(res => {
        
      })
    },
    // 获取角色列表

    getRoleList() {
      let urlLink = `/server/role/getUserList`;
      let param = {
        page: this.pages.pageIndex,
        size: this.pages.pageSize,
        type: this.roleType,
        orgId: this.search.oid,
        deptId: this.search.did,
        userName: this.search.uname,
      };
      this.$ajax.post(urlLink, param).then((res) => {
        this.tableData = res.list;
        this.pages.pageAll = res.total;
      });
    },
    // 设置角色
    setRole(obg, tp) {
      let urlLink = `/server/role/setRole`;
      let rType = "1";
      let oTpye = "1";
      if (tp == 1) {
        if (!obg.auditor) {
          oTpye = "2";
        }
      } else {
        rType = "2";
        if (!obg.thematicResourceManager) {
          oTpye = "2";
        }
      }
      let param = {
        userId: obg.userId,
        operateType: oTpye,
        roleType: rType,
        schoolId: obg.schoolId,
      };
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("设置角色返回", res);
        this.$message({
          message: res,
          type: "success",
        });
        this.getRoleList();
      });
    },
    // 设置学校
    setSchool(obg) {
      let urlLink = `/server/role/setAuditSchool`;
      let param = { userId: obg.userId, schoolIds: obg.schoolIdList.join(",") };
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("设置学校返回", res);
        if (res == "操作成功") {
          this.$message({
            message: "设置学校成功",
            type: "success",
          });
          this.getRoleList();
        }
      });
    },
    // 关闭标签
    handleClose(tag) {
      if (tag == 1) {
        this.search.oname = "";
        this.search.oid = "";
        this.getOrganization();
      } else {
        this.search.did = "";
        this.search.dname = "";
        this.getChild(this.search.oid);
      }
    },
    // 树木结构搜索
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 页码变动
    handleCurrentChange(val) {
      this.pages.pageIndex = val;
      this.getRoleList();
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.pages.pageIndex = 1;
      this.getRoleList();
    },
  },
};
</script>

<style>
.el-tree-node__expand-icon.is-leaf {
  color: #bfbbbb;
}
</style>



// WEBPACK FOOTER //
// src/page/manage/schoolManagerRole.vue